import React from "react";

import CustomerList from "../../components/Customers/CustomerList";
const CustomerPage = props => {
	return (<CustomerList />);
}


export default CustomerPage;